import { css } from 'lit';

export const styles = css`
  :host { display: block;
    
   }

  .container{
    padding : 15px;
  }
  .field-row { 
    display: flex; 
    align-items: center; 
    gap: 1rem; 
    margin-bottom: 1rem; 
    padding: 0.75rem; 
    background: var(--sl-color-neutral-50); 
    border-radius: 8px; 
  }
  
  .field-label { 
    min-width: 120px; 
    font-weight: 600; 
    color: var(--sl-color-neutral-700); 
  }
  
  .field-value { 
    flex: 1; 
    display: flex; 
    align-items: center; 
    gap: 0.5rem; 
  }
  
  .field-value sl-input, 
  .field-value sl-select { 
    flex: 1; 
    min-width: 200px; 
  }

  /* QR Code specific styles */
  .qr-code-row {
    align-items: flex-start;
  }

  .qr-code-value {
    align-items: flex-start;
    flex-direction: column;
  }

  .qr-code-container {
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    width: 100%;
  }

  .qr-code-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .qr-actions {
    display: flex;
    gap: 0.5rem;
  }
`;
